module.exports = __webpack_public_path__ + "img/parking-brake-on.e2ed727a.svg";